import { Routes } from '@angular/router';
import { DashboardLayout } from './layouts/dashboard-layout/dashboard-layout';
import { authGuard, contractOnboardingGuard, guestGuard } from './core/guards/auth.guard';
import { adminMatch, userMatch } from './core/guards/admin.guard';
import { AuthLayout } from './layouts/auth-layout/auth-layout';
import { inactiveSubscriptionGuard, paymentGuard } from './core/guards/payment.guard';

export const routes: Routes = [
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('./features/legal/terms-and-conditions/terms-and-conditions.component').then(
        (m) => m.TermsAndConditionsComponent,
      ),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./features/legal/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent,
      ),
  },
  {
    path: 'lettera-di-nomina',
    loadComponent: () =>
      import('./features/legal/lettera-di-nomina/lettera-di-nomina.component').then(
        (m) => m.LetteraDiNominaComponent,
      ),
  },
  {
    path: '',
    component: AuthLayout,
    canActivate: [guestGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'signup/:code',
        loadComponent: () =>
          import('./features/auth/signup/signup.component').then((m) => m.SignupComponent),
      },
      {
        path: 'signup',
        loadComponent: () =>
          import('./features/auth/signup/signup.component').then((m) => m.SignupComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
      },
    ],
  },
  {
    path: '',
    component: DashboardLayout,
    canActivate: [authGuard],
    canActivateChild: [paymentGuard, contractOnboardingGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'contract-signature',
        loadComponent: () =>
          import('./features/auth/contract-signature/contract-signature.component').then(
            (m) => m.ContractSignatureComponent,
          ),
      },
      {
        path: 'home',
        canMatch: [adminMatch],
        loadComponent: () =>
          import('./features/home/admin-home/admin-home').then((m) => m.AdminHome),
      },
      {
        path: 'home',
        canMatch: [userMatch],
        loadComponent: () => import('./features/home/user-home/user-home').then((m) => m.UserHome),
      },
      {
        path: 'organization-report/:id',
        loadComponent: () =>
          import('./features/organization-report/organization-report').then(
            (m) => m.OrganizationReport,
          ),
      },
      {
        path: 'monitoring',
        loadComponent: () => import('./features/monitoring/monitoring').then((m) => m.Monitoring),
      },
      {
        path: 'documenti-servizio-rdc',
        loadChildren: () =>
          import('./features/documenti-servizio-rdc/documenti-servizio-rdc.routes').then(
            (m) => m.DOCUMENTI_SERVIZIO_RDC_ROUTES,
          ),
      },
      {
        path: 'base-info',
        loadChildren: () => import('./features/base-info/base-info.routing').then((m) => m.routes),
      },
      {
        path: 'document-typology',
        loadChildren: () =>
          import('./features/document-typology/document-typology.routing').then((m) => m.routes),
      },
      {
        path: 'tipologie-documenti-report',
        loadComponent: () =>
          import('./features/tipologie-documenti-report/tipologie-documenti-report').then(
            (m) => m.TipologieDocumentiReport,
          ),
      },
      {
        path: 'conservatori',
        canMatch: [adminMatch],
        loadComponent: () =>
          import('./features/conservatori/conservatori').then((m) => m.Conservatori),
      },
      {
        path: 'conservatori-user',
        loadComponent: () =>
          import('./features/conservatori-user/conservatori-user').then((m) => m.ConservatoriUser),
      },
      {
        path: 'communications',
        loadChildren: () =>
          import('./features/communications/communications.routes').then(
            (m) => m.COMMUNICATION_ROUTES,
          ),
      },
    ],
  },
  {
    path: 'subscription-inactive',
    canActivate: [authGuard, inactiveSubscriptionGuard],
    loadComponent: () =>
      import('./features/payment/subscription-inactive/subscription-inactive').then(
        (m) => m.SubscriptionInactive,
      ),
  },
  {
    path: 'payment/success',
    canActivate: [authGuard],
    loadComponent: () => import('./features/payment/success/success').then((m) => m.PaymentSuccess),
  },
  {
    path: 'payment/cancel',
    canActivate: [authGuard],
    loadComponent: () => import('./features/payment/cancel/cancel').then((m) => m.PaymentCancel),
  },
  {
    path: 'server-error',
    loadComponent: () =>
      import('./features/payment/server-error/server-error').then((m) => m.ServerError),
  },
  {
    path: 'maintenance',
    loadComponent: () => import('./features/maintenance/maintenance').then((m) => m.Maintenance),
  },
  {
    path: '**',
    loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFound),
  },
];
